import { on } from "@ngrx/store";

import { JobToolState } from "../job-tool.reducer";

import { JobFinancialsActions } from "./job-financials.actions";

export const jobFinancialsReducers = [
  on(JobFinancialsActions.openDamageActionsMenuButtonClicked, (state: JobToolState, { damageId }) => {
    return {
      ...state,
      actionsMenuDamageId: damageId,
    }
  }),
  on(JobFinancialsActions.openTransactionsActionsMenuButtonClicked, (state: JobToolState, { transactionId }) => {
    return {
      ...state,
      actionsMenuTransactionsId: transactionId,
    }
  }),
  on(JobFinancialsActions.transactionRemarksToggled, (state: JobToolState, { transactionId }) => {
    const currentValue = state.collapsedTransactionRemarks[transactionId];
    
    return {
      ...state,
      collapsedTransactionRemarks: {
        ...state.collapsedTransactionRemarks,
        [transactionId]: !currentValue,
      }
    };
  }),
];
